import type { PartnerPricing, PartnerTermSection } from '../../api/brand';

export function renderPartnerSections(
  sections: PartnerTermSection[] | undefined,
  pricing?: PartnerPricing | null,
): PartnerTermSection[] {
  const rates = pricing || {};
  const fill = (text: string) => text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key: string) => {
    const value = rates[key as keyof PartnerPricing];
    return value ? String(value) : '';
  });
  return (sections || []).map((section) => ({
    ...section,
    paragraphs: section.paragraphs?.map(fill),
    items: section.items?.map((item) => ({ ...item, text: fill(item.text) })),
  }));
}
